import { getUserObject, relewiseTrack, relewiseTracker, updateTemporaryId } from "utils/relewise";

export default () => {
  document.addEventListener("cart:fetched", () => {
    if (theme.cart) {
      relewiseTrack("Cart");
    }
  });

  window.addEventListener("CookieScriptLoaded", () => {
    updateTemporaryId();
  });

  updateTemporaryId();

  const urlParams = new URLSearchParams(window.location.search);
  const voyadoId = urlParams.get("voyado_user_id");

  if (voyadoId && voyadoId.length) {
    (async () => {
      await relewiseTracker().trackUserUpdate({
        user: getUserObject(),
      });
    })();
  }
};
